export const FLEET_COMMAND_REQUEST = "FLEET_COMMAND_REQUEST";
export const FLEET_COMMAND_SUCCESS = "FLEET_COMMAND_SUCCESS";
export const FLEET_COMMAND_FAILURE = "FLEET_COMMAND_FAILURE";
export const FLEET_COMMAND_RESET   = "FLEET_COMMAND_RESET";

/* Command type values sent in the API payload */
export const CMD_SYSTEM_COMMAND = "SYSTEM_COMMAND";
export const CMD_REBOOT         = "reboot";
export const CMD_UNLOCK         = "unlock";
export const CMD_RESET          = "reset";

/* Success messages */
export const MSG_COMMAND_SUCCESS    = 'Command submitted successfully.';
export const MSG_COMMAND_SUBMITTED  = 'Your command is successfully submitted.';
export const RA_ID_PLACEHOLDER      = 'e.g. 1-100, 300, 310, 315, 500-1000';
export const CMD_PLACEHOLDER      = 'e.g. ls -l';

/* Confirmation messages */
export const CONFIRM_REBOOT  = "Are you sure you want to reboot the RAP/IoTGateway Box?";
export const CONFIRM_UNLOCK  = "Are you sure you want to unlock the RAP/IoTGateway Box's Service account?";
export const CONFIRM_RESET   = "Are you sure you want to reset the RAP/IoTGateway Box's Service account password?";

/* Error messages */
export const ERR_BAD_REQUEST = "Please check RA ID and try again.";
export const ERR_GENERIC     = "Command failed. Please try again.";
